import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NewsArticlesService } from 'src/raksme/services/news/news-articles.service';
import { Router } from '@angular/router';
import { GeneralLabelService } from 'src/raksme/services/general-label/label.service';
import { LanguageService } from 'src/raksme/services/i18n/raksme.languageService';

@Component({
  selector: 'home-news',
  templateUrl: './raksme.homeNewsView.html',
  styleUrls: ['./raksme.homeNewsStyle.css']
})
export class HomeNewsComponent implements OnInit, OnDestroy {
  title = 'rak-sme';

  /** The news fetch failed. */
  public listFailed: boolean = false;

  /** Settled either way, so empty reads differently from loading. */
  public listLoaded: boolean = false;
  public pageData: object;

  public subscriptions: Subscription[] = [];

  public newsData: any = [];

  public allItems: any[] = [];

  @Input("pageContent")
  set setPagesData(_pageData: object){
    this.pageData = _pageData;
  }

  public lang: string = 'en';
  public langUrl: string = '';
  public generalLabels: any = [];

  constructor(private newsService: NewsArticlesService, private router: Router, private labelService: GeneralLabelService, private language: LanguageService){}

  ngOnInit(){

    

    // Exact segment match: includes('/ar') reports Arabic for English URLs
    // such as /business-directory/12/architects.
    this.lang = this.language.lang;
    this.langUrl = this.lang === 'ar' ? '/ar' : '';

    this.subscriptions.push(
      this.labelService.getLabels(this.language.api('general-label')).subscribe(
        res => {
          this.generalLabels = res['data'];
        },
        error => {
          console.log(error);
        }
      )
    );

    this.getNewsList();
  }

  /**
   * Extracted from ngOnInit so a failed fetch has something to retry. It had
   * no failure path: the homepage news strip simply stayed empty, which reads
   * as "no news" rather than "this did not load".
   */
  getNewsList(): void {
    this.listFailed = false;
    this.listLoaded = false;
    this.allItems = [];
    let bodyData: object = {
      "category" : 0
    }
    this.subscriptions.push(
      this.newsService.getNewsOnHome(this.language.api('news'), bodyData).subscribe(
        res => {
          this.newsData = res;

          let i = 1;
          for(var x in this.newsData.data){
            this.allItems.push(this.newsData.data[x]);
            if(i == 3){
              break;
            }
            i++
          }
          this.listLoaded = true;
        },
        () => {
          this.listFailed = true;
          this.listLoaded = true;
        }
      )
    );
  }

  retryList(): void {
    this.getNewsList();
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
